import { render, staticRenderFns } from "./AppQrCode.vue?vue&type=template&id=1b4f9616"
import script from "./AppQrCode.vue?vue&type=script&lang=js"
export * from "./AppQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports